module.exports = __webpack_public_path__ + "static/img/JCI_preventability.1fcba9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/JCI_preventability.png
// module id = h5wT
// module chunks = 1